import { render, staticRenderFns } from "./allocatePop.vue?vue&type=template&id=c942cda0"
import script from "./allocatePop.vue?vue&type=script&lang=js"
export * from "./allocatePop.vue?vue&type=script&lang=js"
import style0 from "./allocatePop.vue?vue&type=style&index=0&id=c942cda0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports